export default {"src":"/_next/static/media/v1_emptyfav.c3c77791.svg","height":161,"width":328,"blurWidth":0,"blurHeight":0};